<template>
<section class="dl-hero">
  <div class="dl-hero__bg" aria-hidden="true"></div>

  <div class="dl-hero__shell">
    <div class="dl-hero__inner">
      <div class="dl-hero__copy">
        <h1 class="dl-hero__title">Download Free Secure VPN APK</h1>

        <p class="dl-hero__desc">
          Protect your privacy and browse securely with a fast,
          <router-link to="/">free VPN</router-link>.
          Connect in one tap, access global servers, and enjoy a safer internet experience on your device.
        </p>

        <div class="dl-hero__tagline">One Tap, and your privacy is set!</div>
        <p class="dl-hero__badge">100% Free | Latest Version</p>

        <div class="dl-hero__actions">
          <a
            class="dl-hero__btn"
            :href="apkDownloadUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true">
              <path d="M12 3v12m0 0l-4-4m4 4l4-4M5 19h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Download Secure VPN
          </a>
        </div>

        <p class="dl-hero__platforms">Available for: Chrome | Edge | Android</p>
      </div>

      <div class="dl-hero__visual">
        <img
          class="dl-hero__img"
          src="@/assets/vpn/download-hero.png"
          alt="Secure VPN app connect screen"
          width="420"
          height="470"
          loading="eager"
        >
      </div>
    </div>
  </div>
</section>
</template>

<script>
const APK_DOWNLOAD_URL =
  'https://apk.secureproxyvpn.com/android/apk/SecureVPN-release-1.0.2_c-20260710171019.apk'

export default {
  name: 'DownloadHeroSection',
  data() {
    return {
      apkDownloadUrl: APK_DOWNLOAD_URL,
    }
  },
}
</script>

<style lang="scss" scoped>
.dl-hero {
  position: relative;
  overflow: hidden;
  padding: 40px 0 0;
}

.dl-hero__bg {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 48% 55% at 88% 40%, rgba(138, 63, 252, 0.14), transparent 65%),
    radial-gradient(ellipse 40% 50% at 8% 70%, rgba(62, 84, 232, 0.08), transparent 55%),
    linear-gradient(180deg, #ffffff 0%, var(--vpn-page, #f6f4ff) 100%);
  pointer-events: none;
}

// 与下方正文栏同宽，内边距与其他模块卡片对齐
.dl-hero__shell {
  position: relative;
  z-index: 1;
  width: var(--vpn-content-width);
  max-width: 100%;
  margin: 0 auto;
  padding: 36px 32px;
  border-radius: 24px;
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.96) 0%, rgba(245, 241, 255, 0.98) 100%);
  border: 1px solid var(--vpn-line, #e8e4f8);
  box-shadow: 0 16px 40px rgba(109, 74, 255, 0.08);
  box-sizing: border-box;
}

.dl-hero__inner {
  display: flex;
  align-items: flex-start;
  // 文案左对齐，图片靠右，缩短中间间隔
  justify-content: space-between;
  gap: 20px;
}

.dl-hero__copy {
  flex: 1 1 auto;
  min-width: 0;
  max-width: none;
}

.dl-hero__title {
  margin: 0 0 16px;
  font-size: clamp(28px, 2.8vw, 40px);
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: var(--vpn-ink, #1f2430);
  font-weight: 800;
}

.dl-hero__desc {
  margin: 0 0 16px;
  color: var(--vpn-ink-muted, #5b6475);
  font-size: 16px;
  line-height: 1.65;
  max-width: none;
  padding-right: 8px;

  a {
    color: var(--vpn-brand, #6d4aff);
    font-weight: 600;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

.dl-hero__tagline {
  margin: 0 0 10px;
  font-size: clamp(20px, 2.4vw, 26px);
  line-height: 1.3;
  font-weight: 800;
  color: var(--vpn-ink, #1f2430);
}

.dl-hero__badge {
  margin: 0 0 22px;
  color: var(--vpn-ink-muted, #5b6475);
  font-size: 15px;
  font-weight: 600;
}

.dl-hero__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 14px;
}

.dl-hero__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 36px;
  min-width: min(280px, 100%);
  max-width: 100%;
  padding: 6px 40px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  box-sizing: border-box;
  background: var(--vpn-brand, #6d4aff);
  color: #fff;
  box-shadow: var(--vpn-shadow-btn, 0 10px 24px rgba(109, 74, 255, 0.35));
  transition: transform 0.2s ease, background 0.2s ease;

  &:hover {
    background: var(--vpn-brand-deep, #5b3fe8);
    transform: translateY(-1px);
  }
}

.dl-hero__platforms {
  margin: 0;
  color: var(--vpn-ink-muted, #5b6475);
  font-size: 14px;
  font-style: italic;
}

.dl-hero__visual {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}

.dl-hero__img {
  width: 200px;
  height: auto;
  display: block;
  border-radius: 18px;
  box-shadow: 0 18px 44px rgba(80, 60, 140, 0.18);
}

@media (max-width: 900px) {
  .dl-hero {
    padding: 20px 0 0;
  }

  .dl-hero__shell {
    width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 20px 16px;
    border-radius: 0;
    border-left: 0;
    border-right: 0;
  }

  .dl-hero__inner {
    flex-direction: column;
    align-items: center;
    gap: 18px;
  }

  .dl-hero__copy {
    max-width: none;
    width: 100%;
    text-align: center;
    order: 1;
  }

  .dl-hero__title {
    font-size: clamp(24px, 6.5vw, 32px);
  }

  .dl-hero__desc {
    margin-left: auto;
    margin-right: auto;
    padding-right: 0;
    font-size: 15px;
  }

  .dl-hero__tagline {
    font-size: clamp(18px, 5vw, 22px);
  }

  .dl-hero__actions {
    justify-content: center;
    width: 100%;
  }

  .dl-hero__btn {
    width: 100%;
    min-width: 0;
    min-height: 44px;
    padding: 10px 20px;
  }

  .dl-hero__visual {
    order: 0;
    width: 100%;
    justify-content: center;
    align-items: center;
  }

  .dl-hero__img {
    width: min(180px, 52vw);
    margin: 0 auto;
  }
}

@media (max-width: 480px) {
  .dl-hero__shell {
    padding: 16px 12px;
  }

  .dl-hero__img {
    width: min(150px, 48vw);
  }

  .dl-hero__platforms {
    font-size: 13px;
  }
}
</style>
